export default "__VITE_ASSET__3615c862__"